<template>
    <div class="promotion-allocation-area__data" :class="colourClass">
        <losenge-date-display
            :start-date="params.data.startDate"
            :end-date="params.data.endDate"
            :compact="true"
        />
    </div>
</template>

<script>
import promotionCellRendererMixin from './promotion-cell-renderer-mixin';

export default {
    name: 'PromotionDateRenderer',
    mixins: [promotionCellRendererMixin],
};
</script>
